import localforage from 'localforage';

const AUDIO_JOB_PREFIX = 'audioJobs';
const AUDIO_JOB_STORAGE_KEYS = ['file', 'updatedAt'];
const STALE_AUDIO_JOB_TTL_MS = 24 * 60 * 60 * 1000;
let activeAudioJobId = null;

export function createAudioJobId() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return crypto.randomUUID();
  return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

export function getAudioStorageKey(key, audioJobId) {
  return `${AUDIO_JOB_PREFIX}:${audioJobId}:${key}`;
}

function jobIdFromKey(key) {
  return key.match(new RegExp(`^${AUDIO_JOB_PREFIX}:([^:]+):`))?.[1] || null;
}

export async function removeAudioJobFromIndexedDB(audioJobId) {
  if (!audioJobId) return true;
  try {
    await Promise.all(AUDIO_JOB_STORAGE_KEYS.map((key) => localforage.removeItem(getAudioStorageKey(key, audioJobId))));
    if (activeAudioJobId === audioJobId) activeAudioJobId = null;
    return true;
  } catch (error) {
    return false;
  }
}

export async function cleanupStaleAudioJobs({ keepAudioJobIds = [], maxAgeMs = STALE_AUDIO_JOB_TTL_MS, now = Date.now() } = {}) {
  try {
    const keep = new Set(keepAudioJobIds);
    const keys = await localforage.keys();
    const jobIds = [...new Set(keys.map(jobIdFromKey).filter(Boolean))];
    await Promise.all(jobIds.map(async (jobId) => {
      if (keep.has(jobId)) return;
      const updatedAt = Number(await localforage.getItem(getAudioStorageKey('updatedAt', jobId))) || 0;
      if (!updatedAt || now - updatedAt > maxAgeMs) await removeAudioJobFromIndexedDB(jobId);
    }));
    return true;
  } catch (error) {
    return false;
  }
}

export async function saveFileToIndexedDB(file, audioJobId = createAudioJobId()) {
  try {
    const previousJobId = activeAudioJobId;
    activeAudioJobId = audioJobId;
    await localforage.setItem(getAudioStorageKey('file', audioJobId), file);
    await localforage.setItem(getAudioStorageKey('updatedAt', audioJobId), Date.now());
    if (previousJobId && previousJobId !== audioJobId) await removeAudioJobFromIndexedDB(previousJobId);
    await cleanupStaleAudioJobs({ keepAudioJobIds: [audioJobId] });
    return true;
  } catch (error) {
    return false;
  }
}
